import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { DisplayImage } from '../../../widgets/components/General/DisplayImage'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers/AssetHelpers'
import { Spinner } from 'react-bootstrap'
import { sendEmailAccountSchemas } from '../SendEmailAccountWizard'

const PreviewTemplate = ({
  investorUsers,
  formik,
  setInvestorUsers,
  showInvestorUsers,
  setShowInvestorUsers,
  stepperState,
  setStepperState,
  storeFileIds,
  paramValue,
  emailData,
  templateData,
  stepper,
  setCurrentSchema,
  emailSignature,
  footer,
}: {
  investorUsers: any
  formik: any
  setInvestorUsers: any
  setShowInvestorUsers: any
  showInvestorUsers: any
  stepperState: any
  setStepperState: any
  storeFileIds: any
  paramValue: any
  emailData: any
  templateData: any
  stepper: any
  setCurrentSchema: any
  emailSignature: any
  footer: any
}) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (investorUsers) {
      let assignInvestor: any = []
      investorUsers.map((item: any) => {
        if (item.checked === true) {
          assignInvestor.push(item)
          return true
        } else {
          return false
        }
      })
      setLoading(false)
      setShowInvestorUsers([...assignInvestor])
    }
  }, [investorUsers, formik.values.selectedInvestorUserIds]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setLoading(true)
    if (paramValue && emailData && emailData.email.status !== 'DRAFT') {
      let { email } = emailData || {}
      let emailFileIDs = email.emailFiles?.map((item: any) => item.fileId)
      formik.setFieldValue('subject', email.subject)
      formik.setFieldValue('quillText', email.body)
      formik.setFieldValue('updateId', email.updateId)
      formik.setFieldValue('pitchDeckId', email.pitchDeckId)
      formik.setFieldValue('files', emailFileIDs)
      setLoading(false)
    } else {
      setLoading(false)
    }
  }, [paramValue, emailData]) // eslint-disable-line react-hooks/exhaustive-deps

  const removeInvestor = (id: number) => {
    let inv = investorUsers.map((item: any) => {
      if (item.investorUserId === id) {
        item.checked = false
      }
      return item
    })
    setInvestorUsers(inv)

    let formikInvestors: any = []
    formik.values.selectedInvestorUserIds.map((item: any) => {
      if (item.checked === true) {
        formikInvestors.push(item)
        return true
      } else {
        return false
      }
    })

    formik.setFieldValue('selectedInvestorUserIds', formikInvestors)

    let set: any = []
    showInvestorUsers.map((item: any) => {
      if (item.checked === true) {
        set.push(item)
        return true
      } else {
        return false
      }
    })

    setShowInvestorUsers([...set])
  }
  return loading ? (
    <div className='d-flex justify-content-center'>
      <Spinner animation={'border'} />
    </div>
  ) : (
    <div className='col-12 row'>
      <div className=' col-12 col-lg-8 col-xl-8 col-md-8 border rounded  p-2'>
        <div className='col-12'>
          <div className='d-flex justify-content-between pb-3'>
            <p className='align-self-md-center  mb-0'>
              {formatMessage({ id: 'Subject' })}:{formik.values.subject}
            </p>
            <div>
              {(!paramValue || (emailData && emailData.email.status === 'DRAFT')) && (
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={(e) => {
                    if (!stepper.current) {
                      return
                    }
                    stepper.current.goto(1)
                    setCurrentSchema([{ ...sendEmailAccountSchemas[0] }])
                    setStepperState(stepperState.current.goto(1))
                  }}
                >
                  {formatMessage({ id: 'Edit' })}
                </button>
              )}
            </div>
          </div>
          {paramValue ? (
            <div>
              <div dangerouslySetInnerHTML={{ __html: emailData?.email.body }}></div>
              <div dangerouslySetInnerHTML={{ __html: emailData?.email.footer }}></div>
            </div>
          ) : (
            <div>
              <div>{formik.values.quillText.replace(/(<([^>]+)>)/gi, '')}</div>
              {footer && <div>{emailSignature?.replace(/(<([^>]+)>)/gi, '')}</div>}
            </div>
          )}

          <div className='mt-5 d-flex gap-8 flex-wrap'>
            {formik.values.pitchDeckId && (
              <div className='d-flex gap-3 align-items-center'>
                <div className='d-flex gap-0 align-items-center'>
                  <div>
                    <img
                      alt=''
                      className='w-25px me-3'
                      src={toAbsoluteUrl('/media/icons/file_extensions/pdf.svg')}
                    />
                  </div>
                  <p className='m-0'>{formatMessage({ id: 'Pitch Deck Attached' })}</p>
                </div>
              </div>
            )}
            {formik.values.updateId && (
              <div className='d-flex gap-3 align-items-center'>
                <div className='d-flex gap-0 align-items-center'>
                  <div>
                    <img
                      alt=''
                      className='w-25px me-3'
                      src={toAbsoluteUrl('/media/icons/file_extensions/pdf.svg')}
                    />
                  </div>
                  <p className='m-0'>{formatMessage({ id: 'Investor Update Attached' })}</p>
                </div>
              </div>
            )}
            {storeFileIds?.length > 0 &&
              storeFileIds.map((file: any) => (
                <div key={file.id} className='d-flex gap-3 align-items-center'>
                  <div className='d-flex gap-0 align-items-center'>
                    <div>
                      {file?.name.split('.').pop() === 'pdf' ? (
                        <img
                          alt=''
                          className='w-25px me-3'
                          src={toAbsoluteUrl('/media/icons/file_extensions/pdf.svg')}
                        />
                      ) : (
                        <img
                          alt=''
                          className='w-50px me-3'
                          src={toAbsoluteUrl('/media/svg/files/blank-image.svg')}
                        />
                      )}
                    </div>
                    <p className='mt-1'>{`${file.name.substring(0, 25)}${file.name.length > 25 ? '...' : ''
                      }`}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className='col-12 col-lg-4 col-xl-4 col-md-4'>
        <div className='  border rounded p-2'>
          <h5 className='ps-3 pt-3'>
            To {showInvestorUsers.length} {formatMessage({ id: 'people' })}
          </h5>
          <div className='h-175px me-3 overflow-auto p-2 '>
            <table className='bg-gray-300i w-100 border rounded'>
              <tbody>
                {showInvestorUsers &&
                  showInvestorUsers.map((item: any) => (
                    <tr key={item?.investorId}>
                      <td className='w-25px px-3 py-2'>
                        {item && (
                          <DisplayImage
                            imgName={item?.file?.name}
                            width='24px'
                            height='24px'
                            className='border object-contain rounded-circle'
                            alt={item?.file?.name || ''}
                          />
                        )}
                      </td>
                      <td className='pe-10'>{item?.name}</td>
                      {(!paramValue || (emailData && emailData.email.status === 'DRAFT')) && (
                        <td>
                          <i
                            className='fa fa-close text-danger cursor-pointer'
                            onClick={() => removeInvestor(item?.investorUserId)}
                          ></i>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
export { PreviewTemplate }
